import Iconify from "src/components/iconify";
import { Stack, Typography, Button, Badge, Box } from "@mui/material";
import { CustomDomain } from "src/context/api/sso/models";
import { ConfirmDialog } from "src/components/custom-dialog";
import { useDeleteCustomDomainMutation } from "src/context/api/sso/api";
import { useCreateCustomDomainMutation } from "src/context/api/sso/api";
import { useLocales } from "src/locales";
import { useBoolean } from "src/hooks/use-boolean";
import { enqueueSnackbar } from "notistack";

interface DomainProps {
    domain: CustomDomain;
    domains: CustomDomain[];
    resyncDomains: () => void;
}

export default function Domain({ domain, domains, resyncDomains }: DomainProps) {
    const { t } = useLocales();
    const [createDomain,] = useCreateCustomDomainMutation();
    const [deleteDomain,] = useDeleteCustomDomainMutation();
    const { value: confirmDialogOpen, onTrue: openConfirmDialog, onFalse: closeConfirmDialog } = useBoolean();



    const handleCreateDomain = (domain: CustomDomain) => {
        const createRequest = createDomain({
            name: domain.name,
            domains: domain.aliases,
            identifier: domain.identifier,
        }).unwrap();

        createRequest.then((res) => {
            if (res.insert === 1) {
                enqueueSnackbar(t('dashboard.admin.sso.domain_created'), { variant: 'success' });
                resyncDomains();
            } else {
                enqueueSnackbar(t('dashboard.admin.sso.domain_creation_failed'), { variant: 'error' });
            }
        }).catch((err) => {
            enqueueSnackbar(t('dashboard.admin.sso.domain_creation_failed'), { variant: 'error' });
        });
    }

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center" key={domain.identifier}>
                <Stack direction="column" justifyContent="space-between" alignItems="start">
                    <Typography variant="body1">{domain.aliases.join(', ')}</Typography>
                    <Typography variant="body2" color="text.secondary">{domain.strategy}</Typography>

                </Stack>
                {domain.type === 'local' && !domain.synced && (
                    <Typography variant="body1">{t('dashboard.admin.sso.local_domain_is_unsynced')}</Typography>
                )}
                <Stack direction="row" justifyContent="space-between" alignSelf="flex-end" alignItems="center">
                    {
                        domain.synced ? (
                            <Box padding={3}>
                                <Badge sx={{ '.MuiBadge-badge': {
                                    borderRadius: '27px',
                                    width: '27px',
                                    height: '27px',
                                } }} color="success" badgeContent={<Iconify icon="mingcute:check-line" />} />
                            </Box>
                        )
                            : <Button variant="contained" onClick={() => handleCreateDomain(domain)} startIcon={<Iconify icon="mingcute:add-line" />}>
                                {t('dashboard.admin.sso.sync_domain')}
                            </Button>
                    }
                </Stack>
            </Stack>
        </>
    )
}